import { RawDraftContentState } from 'draft-js';
import { isNull } from 'lodash/fp';
import React, { useCallback } from 'react';

import { useAppDispatch } from '../../../../hooks/react-redux';
import { isEmpty, WYSIWYG } from '../../../shared/wysiwyg/WYSIWYG';
import { SendEmailScheduler, setScheduledEmailContent } from '../store';
import styles from '../Workflow.module.scss';
import { EmailHeaderElements } from './EmailHeaderElements';

interface ScheduleEmailContentProps {
    event: SendEmailScheduler;
    testId: string;
    isEditing: boolean;
}

export const ScheduleEmailContent: React.FC<ScheduleEmailContentProps> = ({ event, testId, isEditing }) => {
    const dispatch = useAppDispatch();

    const { content } = event;
    const { userIds, subject, wysiwygTemplate } = content;

    const setEmailUserIds = useCallback((value: number[] | null) => dispatch(setScheduledEmailContent('userIds', value)), [dispatch]);
    const setEmailSubject = useCallback((value: string) => dispatch(setScheduledEmailContent('subject', value)), [dispatch]);
    const setEmailBody = useCallback((rawValue: RawDraftContentState) => {
        if (isEmpty(rawValue)) {
            if (!isNull(wysiwygTemplate)) {
                dispatch(setScheduledEmailContent('wysiwygTemplate', null));
            }
        } else {
            dispatch(setScheduledEmailContent('wysiwygTemplate', rawValue));
        }
    }, [dispatch, wysiwygTemplate]);

    return (
        <div className={styles.emailContentTabWrapper} data-testid={`${testId}-wrapper`}>
            <EmailHeaderElements userIds={userIds} subject={subject} updateSubject={setEmailSubject} updateUserIds={setEmailUserIds} testId={testId} isEditing={isEditing} />
            <div className={styles.emailBodyWrapper} data-testid={`${testId}-body-wrapper`}>
                <WYSIWYG
                    content={wysiwygTemplate}
                    updateContent={val => setEmailBody(val)}
                    height='100%'
                    maxHeight='100%'
                    minHeight='100%'
                    disabled={!isEditing}
                    toolbarHidden={!isEditing}
                />
            </div>
        </div>
    );
};

